import { render, staticRenderFns } from "./IosShareInfo.vue?vue&type=template&id=4e5026e7"
import script from "./IosShareInfo.vue?vue&type=script&lang=js"
export * from "./IosShareInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports